import React, { Component } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';

class MainIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: {}
    };
  }

  componentWillReceiveProps(newProps) {
    // Handle prop updates
  }

  render() {
    const { session, CPS, balance } = this.props;

    const statsConfig = [
      {
        title: 'Sessions',
        value: session.value,
        limit: session.limit,
        icon: 'icon-history',
        gradient: 'teal'
      },
      {
        title: 'CPS',
        value: CPS.value,
        limit: CPS.limit,
        icon: 'icon-phone-wave',
        gradient: 'pink'
      },
      {
        title: 'Balance',
        value: balance.value,
        limit: balance.limit,
        icon: 'icon-wallet',
        gradient: 'primary'
      }
    ];

    return (
      <div className="row" style={{ animation: 'fadeIn 0.4s ease' }}>
        {statsConfig.map((stat, index) => (
          <div key={stat.title} className="col-md-4">
            <div
              className={`card card-body bg-${stat.gradient} text-white has-bg-image`}
              style={{
                position: 'relative',
                overflow: 'hidden',
                cursor: 'default',
                transition: 'transform 200ms ease, box-shadow 200ms ease',
                animation: `fadeInUp 0.5s ease ${index * 0.1}s both`
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '';
              }}
            >
              {/* Header with title and icon */}
              <div className="media mb-3" style={{ position: 'relative', zIndex: 1 }}>
                <div className="media-body">
                  <h6
                    className="font-weight-semibold mb-0"
                    style={{
                      fontSize: '1.375rem',
                      fontWeight: 600,
                      letterSpacing: '-0.02em',
                      display: 'flex',
                      alignItems: 'baseline',
                      gap: '0.5rem'
                    }}
                  >
                    <span style={{ opacity: 0.9, fontSize: '1rem' }}>{stat.title}</span>
                    <span style={{ fontWeight: 700, fontSize: '1.75rem' }}>
                      {stat.value !== undefined ? stat.value.toLocaleString() : '...'}
                    </span>
                  </h6>
                </div>
                <div className="ml-3 align-self-center">
                  <i
                    className={stat.icon}
                    style={{
                      fontSize: '2.75rem',
                      opacity: 0.85,
                      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
                    }}
                  />
                </div>
              </div>

              {/* Progress bar */}
              <div className="mb-3" style={{ position: 'relative', zIndex: 1 }}>
                <ProgressBar
                  animated
                  now={stat.value}
                  max={stat.limit || 100}
                  variant="white"
                  style={{
                    height: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    borderRadius: '9999px',
                    overflow: 'hidden'
                  }}
                />
              </div>

              {/* Limit display */}
              <div
                style={{
                  fontSize: '1rem',
                  position: 'relative',
                  zIndex: 1,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <span style={{ opacity: 0.85, fontWeight: 500 }}>Limit</span>
                <span style={{ fontWeight: 700, fontSize: '1.125rem' }}>
                  {stat.limit !== undefined ? stat.limit.toLocaleString() : '...'}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default MainIndex;
